import type { FluxErrorEntityErrorCodes } from '../types.js';

export const LabelErrorCodes = {
  LabelBatchNotFound: {
    code: 'label/batch-not-found',
    message: 'Uma ou mais etiquetas não foram encontradas.',
    explanation: 'Uma ou mais etiquetas que você está tentando acessar não foram encontradas.',
    localizations: {},
  },
  LabelNotFound: {
    code: 'label/not-found',
    message: 'Etiqueta não encontrada.',
    explanation: 'A etiqueta que você está tentando acessar não foi encontrada.',
    localizations: {},
  },
} as const satisfies FluxErrorEntityErrorCodes<'label'>;
